$ = jQuery;

$slickElement = $('.testimonials--carousel');
$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    $status = $('.paging_infos');

    var i = (currentSlide ? currentSlide : 0) + 1;
    if (i <= 9) {
          $status.text('0' + i + ' / 0' + slick.slideCount);
    } else {
          $status.text(i + ' / ' + slick.slideCount);
    }
});


$slickElement.slick({
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    arrows: true,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow slick-prev border-0 position-absolute">←</button><div class="paging_infos"></div>',
    nextArrow: '<button class="slide-arrow next-arrow slick-next border-0 position-absolute">→</button>',
});